import { z } from 'zod'
import { Model } from './architecture'

export const AddressValidation = z.object({
  value: z.string({ required_error: '[Address] value is required' }),
})

export class Address extends Model {
  static create({ value }: z.infer<typeof AddressValidation>) {
    AddressValidation.parse({ value })
    return new Address(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
